import { httpRepo } from "configurations/axios";
import {
  PAGO_COBROS_REQUEST,
  PAGO_COBROS_SUCCESS,
  PAGO_COBROS_ERROR,
  PAGO_COBROS_RESET,
} from "redux/types/pagoCobrosTypes";

const API_PAGO_COBROS = "/modulo/contable/pago-cobro/";

const getErrorMessage = (error, fallback) =>
  error?.response?.data?.message ||
  error?.response?.data?.apierror?.mensaje ||
  error?.response?.data ||
  error?.message ||
  fallback;

export const fetchPagosCobros = (ruc, anio, mes) => async (dispatch) => {
  dispatch({ type: PAGO_COBROS_REQUEST });

  try {
    if (!ruc) throw new Error("No se pudo determinar el RUC del usuario.");

    const params = new URLSearchParams();
    if (anio) params.append("anio", anio);
    if (mes) params.append("mes", mes);
    const query = params.toString() ? `?${params.toString()}` : "";

    const response = await httpRepo.get(`${API_PAGO_COBROS}${ruc}${query}`);

    dispatch({ type: PAGO_COBROS_SUCCESS, payload: response.data });

    return response.data;
  } catch (error) {
    const message = getErrorMessage(
      error,
      "No se pudo cargar la información de pagos y cobros.",
    );

    dispatch({ type: PAGO_COBROS_ERROR, payload: message });

    throw error;
  }
};

export const resetPagosCobros = () => ({ type: PAGO_COBROS_RESET });
